import React, { useEffect, useState } from 'react';
import 'react-casino-roulette/dist/index.css';
import { ChipList, RouletteWheel, RouletteTable, useRoulette } from 'react-casino-roulette';
import whiteChip from '../public/images/blank-chips/white-chip.png';
import blueChip from '../public/images/blank-chips/blue-chip.png';
import blackChip from '../public/images/blank-chips/black-chip.png';
import cyanChip from '../public/images/blank-chips/cyan-chip.png';
import './App.css';

const chips = { '0.1': whiteChip, '1': blueChip, '10': blackChip, '100': cyanChip };

async function api(path, options) {
  const response = await fetch(path, { credentials: 'same-origin', ...options });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok === false) throw new Error(data.message || `HTTP ${response.status}`);
  return data;
}

export const App = () => {
  const { bets, total, onBet, updateAllBets, clearBets } = useRoulette();
  const [selectedChip, setSelectedChip] = useState('1');
  const [balance, setBalance] = useState(0);
  const [winningBet, setWinningBet] = useState('-1');
  const [wheelStart, setWheelStart] = useState(false);
  const [status, setStatus] = useState('Place chips on the table.');
  const [pendingResult, setPendingResult] = useState(null);
  const [previousBets, setPreviousBets] = useState(null);

  useEffect(() => {
    api('/api/casino-collection').then((data) => setBalance(Number(data.virtualWallet?.balance || 0))).catch((error) => setStatus(error.message));
  }, []);

  const spin = async () => {
    if (wheelStart || total <= 0) return setStatus('Place at least one chip.');
    setWinningBet('-1');
    setWheelStart(true);
    setStatus('The server is determining the winning number…');
    try {
      const wager = Object.entries(bets).map(([id, bet]) => ({ id, amount: Number(bet.amount), numbers: bet.payload }));
      setPreviousBets(Object.fromEntries(Object.entries(bets).map(([id, bet]) => [id, Number(bet.amount)])));
      const data = await api('/api/casino-collection/play', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ game: 'roulette', stake: Number(total), bets: wager }),
      });
      setBalance(Number(data.virtualWallet?.balance || 0));
      setPendingResult(data.result);
      setWinningBet(String(data.result.number));
    } catch (error) {
      setWheelStart(false);
      setStatus(error.message);
    }
  };

  const finishSpin = () => {
    const payout = Number(pendingResult?.payout || 0);
    setStatus(payout > 0 ? `${pendingResult.label}. Win: ${payout.toFixed(2)} AMD VIRTUAL.` : `${pendingResult?.label || 'No win'}.`);
    clearBets();
    setWheelStart(false);
    setPendingResult(null);
  };

  return <main className="amd-roulette">
    <header><div><small>EUROPEAN ROULETTE</small><h1>AMD ROULETTE</h1></div><strong>{balance.toFixed(2)} AMD</strong></header>
    <section className="roulette-layout">
      <RouletteWheel start={wheelStart && winningBet !== '-1'} winningBet={winningBet} onSpinningEnd={finishSpin} layoutType="european" spinDuration={4} />
      <div className="table-scroll"><RouletteTable chips={chips} bets={bets} onBet={onBet(selectedChip)} readOnly={wheelStart} layoutType="european" height="330px" /></div>
    </section>
    <section className="roulette-controls">
      <div><span>CHIP</span><ChipList chips={chips} selectedChip={selectedChip} onChipPressed={setSelectedChip} budget={balance} chipSize={52} /></div>
      <div className="roulette-totals"><span>BET</span><strong>{Number(total).toFixed(2)} AMD</strong></div>
      <button type="button" onClick={() => previousBets && updateAllBets(previousBets)} disabled={wheelStart || !previousBets}>REPEAT</button>
      <button type="button" onClick={clearBets} disabled={wheelStart || total <= 0}>CLEAR</button>
      <button className="spin" type="button" onClick={spin} disabled={wheelStart || total <= 0}>SPIN</button>
    </section>
    <p className="status">{status}</p>
  </main>;
};
